import React from 'react';
import './LabelInput.scss';
import Input from "../../UI/Input";

const LabelInput = (props) => {

    return (

        <div className="label-input">
            <label htmlFor={props.id}>{props.labelText}</label>
            <Input
                onChange={props.onChange}
                id={props.id}
                value={props.value}
                type={props.type}
                placeholder={props.placeholder}
                className={props.className}/>
        </div>
    );
}

export default LabelInput;